import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'react-emotion';
//import theme from '@jetshop/ui/utils/theme';

import { ReactComponent as CheckerSVG } from '../../../svg/Check.svg';
import { ReactComponent as CrossSVG } from '../../../svg/Close.svg';

const IconSharedCSS = css`
  position: relative;
  top: 3px;
  width: 1.1rem;
  height: 1rem;
  margin-right: 0.75rem;
`;

const CheckerIcon = styled(CheckerSVG)`
${IconSharedCSS}
fill: ${({ theme }) => theme.colors.green};
`;

const CrossIcon = styled(CrossSVG)`
${IconSharedCSS}
fill: ${({ theme }) => theme.colors.red};
`;

const StockP = styled('p')`
  flex: 1 0 auto;
  min-width: 60px;
  padding-left: 20px;
`;

const StockStatusIndicator = ({ status, text }) => {
  return (
    <StockP>
      {status === 'inStock' ? <CheckerIcon /> : <CrossIcon />}
      {text}
    </StockP>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string
};

export default StockStatusIndicator;
